export const enum TrackingEvents {
  FYTScreen = `[FYT] FYT Screen`, // implemented
  ClickJoinOrg = `[FYT] Clicked Join Org`, // implemented
  ClickCreateNewOrg = `[FYT] Clicked Create New Org`, // implemented
  PendingInvitePage = `[FYT] Pending Invite Page`, // implemented
  ImplementationGuideClicked = `[FYT] Clicked Implmentation Guide`, // implemented
  MixpanelHelpDocsClicked = `[FYT] Clicked Mixpanel Help Docs`, // implemented
  MixpanelYoutubeClicked = `[FYT] Clicked Mixpanel Youtube`, // implemented
  ContactSupportClicked = `[FYT] Clicked Contact Support`, // implemented
  CreateOrgScreen = `[FYT] Create Org Screen`, // implemented
  CreateProjectScreen = `[FYT] Create Project Screen`, // implemented
  FinishedSetup = `[FYT] Finished Setup`, // implemented

  // Specific to Segmented Onboarding Version
  BackToJoin = `[FYT] Back To Join`,
  JoinOrgScreen = `[FYT] Join Org Screen`,

  MIXPANEL_HELP_SETTINGS_CLICKED = `[FYT] Mixpanel Help Center Clicked`,
  CONTACT_SUPPORT_CLICKED = `[FYT] Contact Support Clicked`,
}
